import { actions } from './';

const initialState = () => {
    return {
        items: [],
        isBusy: false,
        updatePricing: true,
        error: null
    };
};

export default function(state = initialState(), action) {
    switch (action.type) {
        case actions.CLEAR_RATINGS: {
          return { ...state, items: [] }
        }

        case actions.FETCH_RATINGS: {
            return {
                ...state,
                isBusy: true,
                error: null
            };
        }

        case actions.FETCH_RATINGS_SUCCESS: {
            const items = [action.value];
            return {
                ...state,
                isBusy: false,
                updatePricing: true,
                error: null,
                items
            };
        }

        case actions.FETCH_RATINGS_FAILURE: {
            return {
                ...state,
                isBusy: false,
                updatePricing: false,
                error: action.value
            };
        }

        case actions.UPDATE_RATINGS: {
            const items = [action.value];
            return {
                ...state,
                isBusy: false,
                error: null,
                items
            };
        }

        case actions.FETCH_RATINGS_NO_PRICING: {
            return {
                ...state,
                isBusy: true,
                updatePricing: false,
                error: null
            };
        }

        case actions.FETCH_RATINGS_NO_PRICING_SUCCESS: {
            const items = [action.value];
            return {
                ...state,
                isBusy: false,
                error: null,
                updatePricing: false,
                items
            };
        }

        case actions.FETCH_RATINGS_NO_PRICING_FAILURE: {
            return {
                ...state,
                isBusy: false,
                updatePricing: false,
                error: action.value
            };
        }

        default:
            return state;
    }
}
